export const formatAvgTime = (seconds: number) => {
  if (seconds < 1) return '1s'

  const totalSeconds = Math.ceil(seconds)

  const minutes = Math.floor(totalSeconds / 60)
  const remainingSeconds = totalSeconds % 60

  if (minutes > 0) {
    return `${minutes}m${remainingSeconds}s`
  }

  return `${totalSeconds}s`
}
